import React, { useState } from "react";
import VideoModal from "../../Helpers/VideoModal.component";
import Typewriter from "typewriter-effect";
import heroMobileImg from "../../srcAssets/Images/Hero/samskrithigoshala - hero - phone1.5x_450.jpg";
import "./Hero.style.css";

const Hero = () => {
  const [showVideoGallery, setShowVideGallery] = useState(false);

  const handleModal = (state) => {
    setShowVideGallery(state);
  };

  const navigateTo = (id) => {
    let offsetTop = document.getElementById(id).offsetTop;
    window.scroll({
      top: offsetTop - 60,
      behavior: "smooth",
    });
  };

  const navigateToEngage = (id) => {
    let offsetTop = document.getElementById(id).offsetTop;
    window.scroll({
      top: offsetTop - 190,
      behavior: "smooth",
    });
  };

  return (
    <>
      <section id="hero" className="d-flex align-items-center">
        <img src={heroMobileImg} className="hero-hidden-img" />
        <div className="container text-center text-lg-start hero-wrapper">
          <div className="row mw-100 text-light mt-3">
            <div className="col-lg-12 px-0 text-center text-lg-left">
              <h1 className="text-center hero-typewriter">
                <Typewriter
                  className="type-writer"
                  options={{
                    skipAddStyles: true,
                    strings: ["Guided by Purpose.", "Driven by Compassion."],
                    autoStart: true,
                    loop: true,
                    delay: 125,
                  }}
                />
              </h1>
              <div className="d-flex flex-column mobileBackground">
                <div className="mt-5 my-md-4 d-flex align-items-center justify-content-center order-2 order-sm-1n video-btn">
                  <p
                    className="play-btn"
                    onClick={() => {
                      handleModal(true);
                    }}
                  ></p>
                </div>
                <h4 className="ml-1 my-3 text-center order-1 order-sm-2 position-relative hero-paragraph">
                  Advocate compassion. Involve Communities. Lead conservation.
                </h4>
                <div className="btns d-flex justify-content-center order-3 position-relative flex-wrap">
                  <p
                    className="btn-menu animated fadeInUp scrollto mx-2 mt-2"
                    onClick={() => navigateToEngage("v-pills-adopt")}
                  >
                    Volunteer
                  </p>
                  <p
                    className="btn-menu animated fadeInUp scrollto mx-2 mt-2"
                    onClick={() => navigateTo("video-gallery")}
                  >
                    Video
                  </p>
                  <p
                    className="btn-menu animated fadeInUp scrollto mx-2 mt-2"
                    onClick={() => navigateTo("productsSection")}
                  >
                    Buy
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {showVideoGallery ? (
        <VideoModal
          url="https://www.youtube.com/embed/u6xyn7826d8?autoplay=1&showinfo=0&controls=0"
          onClose={() => handleModal(false)}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default Hero;
